import type { IOrgRepository } from '../repositories/IOrgRepository.js';

interface Dependencies {
  orgRepository: IOrgRepository;
}

export interface TransferOrgOwnerInput {
  orgId: string;
  newOwnerId: string;
}

export function createTransferOrgOwnerUseCase({ orgRepository }: Dependencies) {
  return async function transferOrgOwner(input: TransferOrgOwnerInput): Promise<void> {
    return orgRepository.transferOwner(input.orgId, input.newOwnerId);
  };
}
